module.exports = __webpack_public_path__ + "static/img/demo_user4.5f31f39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/placeholders/demo_user4.png
// module id = cYFN
// module chunks = 31